import {Component, Injector, ViewChild} from '@angular/core';
import {TableComponent} from "../../ui/table/table.component";
import {NgxSmartModalService} from "ngx-smart-modal";
import {ShopService} from "../../../services/shop/shop.service";
import {ActivatedRoute} from "@angular/router";
import {ProductSize} from "../../../models/shop/ProductSize";
import {Product} from "../../../models/shop/product";
import Swal from "sweetalert2";
import {BaseComponent} from "../../base/base.component";
import {ProductCategory} from "../../../models/shop/productCategory";

@Component({
  selector: 'app-shop-category',
  templateUrl: './shop-category.component.html',
  styleUrls: ['./shop-category.component.scss']
})
export class ShopCategoryComponent extends BaseComponent {
  @ViewChild('cateogoryList') categoryList: TableComponent | undefined;
  companyId: string = localStorage.getItem('wisper_companyId') ?? '';


  constructor(public serviceInjector: Injector,
              private modal: NgxSmartModalService,
              public shopService: ShopService,
              private router: ActivatedRoute) {
    super(serviceInjector);
  }

  async ngAfterViewInit() {
    this.showSpinner();
    this.categoryList?.loadData(`/productCategories`, {companyId: this.companyId}, ((item: any) => new ProductCategory(item)))
    this.hideSpinner();
  }

  showEditCategoryModal(categoryToEdit: Product) {
    this.modal.getModal('editCategoryModal').setData(categoryToEdit);
    this.modal.getModal('editCategoryModal').open();
  }

  showAddCategoryModal() {
    let newCategory = new ProductCategory();
    this.modal.setModalData(newCategory, 'addCategoryModal');
    this.modal.getModal('addCategoryModal').open();
  }

  async addCategory(categoryToAdd: ProductSize) {
    this.spinner.show();

    categoryToAdd['companyId'] = this.companyId;
    let response = await this.shopService.addCategory(categoryToAdd);
    this.spinner.hide();

    if (response.success) {
      Swal.fire({
        icon: 'success',
        title: 'Categoria creata con successo'
      });
      //refresh
      this.categoryList?.reloadPage();
      this.modal.getModal('addCategoryModal').close();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore durante la creazione della categoria"
      });
    }
  }

  async editCategory(categoryToAdd: ProductSize) {
    this.spinner.show();

    console.log(this.companyId)
    categoryToAdd['companyId'] = this.companyId
    let response = await this.shopService.editCategory(categoryToAdd.id ?? '', categoryToAdd);

    if (response.success) {
      this.spinner.hide();
      Swal.fire({
        icon: 'success',
        title: 'Categoria modificata con successo'
      });
      //refresh
      this.modal.getModal('editCategoryModal').close();
    } else {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: "Errore, riprova a modificare la categoria"
      });
    }
  }

  deleteCategory = async (categoryId: string) => {
    const success = (await this.shopService.deleteCategory(categoryId)).success;
    if (success) {
      Swal.fire({
        icon: 'success',
        title: 'Categoria eliminata con successo!',
      });
      //refresh
      this.categoryList?.reloadPage();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore nell'eliminazione della categoria",
      })
    }
  }
}
